module.exports = "//docs.gtimg.com/slide/img/_/node_modules/@tencent/docs-design-resources/image/mobile/gif/ai_newlogo_72-87bd45.gif";